import { render, staticRenderFns } from "./orderReturn.vue?vue&type=template&id=657bae94&scoped=true"
import script from "./orderReturn.vue?vue&type=script&lang=js"
export * from "./orderReturn.vue?vue&type=script&lang=js"
import style0 from "./orderReturn.vue?vue&type=style&index=0&id=657bae94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657bae94",
  null
  
)

export default component.exports